var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { normalizeObject, dataLayerPush, toEhashAsync, isCoverTheFeeProduct, SPONSORSHIP_PRODUCT_SKU, CHOSEN_PRODUCT_SKU } from "../shared/utils";
function mapProductItems(items, orderData) {
    var itemBrandsCategories = [];
    var includesSponsorshipProductName = function (itemName) { return itemName.includes("Child Sponsorship -"); };
    var includesChosenProductName = function (itemName) { return itemName.includes("Chosen Sponsorship"); };
    var filterOutCoverTheFee = (function (_a) {
        var item_id = _a.item_id;
        return !isCoverTheFeeProduct(item_id);
    });
    var getItemBrand = function (itemName, orderItem) {
        if (orderItem['sku'] === CHOSEN_PRODUCT_SKU || includesChosenProductName(itemName)) {
            return "chosen_sponsorship";
        }
        else if (orderItem['sku'] === SPONSORSHIP_PRODUCT_SKU || includesSponsorshipProductName(itemName)) {
            return "sponsorship";
        }
        else {
            return "gift_catalog";
        }
    };
    var getItemSku = function (itemMetaData, orderItem) {
        if (orderItem['sku']) {
            return orderItem['sku'];
        }
        else if (includesChosenProductName(orderItem.name)) {
            return CHOSEN_PRODUCT_SKU;
        }
        else if (includesSponsorshipProductName(orderItem.name)) {
            return SPONSORSHIP_PRODUCT_SKU;
        }
        else {
            return itemMetaData["_sku"] || "";
        }
    };
    var getItemName = function (orderItem) {
        if (includesChosenProductName(orderItem.name)) {
            return "chosen_sponsorship";
        }
        else if (includesSponsorshipProductName(orderItem.name)) {
            return "child_sponsorship";
        }
        else {
            return orderItem.name;
        }
    };
    var getItemCategory = function (orderItem) {
        return orderItem['category'] || "";
    };
    var _a = (function (items) {
        var hasHonorCard = false;
        var mappedProducts = items.map(function (item) {
            var itemMetaData = item.meta_data.reduce(function (meta, _a) {
                var _b;
                var key = _a.key, value = _a.value;
                return __assign(__assign({}, meta), (_b = {}, _b[key] = value, _b));
            }, {});
            var itemSku = getItemSku(itemMetaData, item);
            var itemName = getItemName(item);
            var itemCategory = getItemCategory(item);
            var variant = (function (uom) {
                return uom === "mon"
                    ? "monthly"
                    : uom === "yr" ? "yearly"
                        : "one-time";
            })(itemMetaData === null || itemMetaData === void 0 ? void 0 : itemMetaData.pa_uom);
            if (!hasHonorCard && itemMetaData['_honor_card_enabled']) {
                hasHonorCard = true;
            }
            var item_brand = getItemBrand(item.name, item);
            itemBrandsCategories.push(item_brand);
            return {
                item_brand: item_brand,
                item_category: itemCategory,
                item_id: itemSku,
                item_list_name: "", // This is ambiguous
                item_name: itemName,
                item_variant: "".concat(variant, ":").concat(item.total),
                price: +item.total,
                quantity: +item.quantity,
            };
        }).filter(filterOutCoverTheFee);
        var event_label = itemBrandsCategories.reduce(function (reducedCategory, category) {
            if (category === "chosen_sponsorship" || reducedCategory === "chosen_sponsorship") {
                return "chosen_sponsorship";
            }
            else if (category === "sponsorship" || reducedCategory === "sponsorship") {
                return "sponsorship";
            }
            return "gift_catalog";
        }, "gift_catalog");
        return [
            mappedProducts,
            event_label,
            hasHonorCard
        ];
    })(items), productItems = _a[0], event_label = _a[1], hasHonorCard = _a[2];
    return {
        productItems: productItems,
        event_label: event_label,
        hasHonorCard: hasHonorCard
    };
}
;
function getPaymentMethod(orderData) {
    var paymentMethod = orderData.payment_method;
    var paymentMethods = {
        "_bt_paypal": "paypal",
        "_bt_applepay": "apple_pay",
        "_bt_googlepay": "google_pay",
        "_wp_applepay": "apple_pay",
        "_wvus_eft": "bank_withdrawl",
        "_wvus_new_credit_card_tx": "credit_card",
        "_wvus_existing_credit_card_v2": "credit_card",
        "Check": "Check"
    };
    return paymentMethods[paymentMethod] || undefined;
}
function getCheckoutType(paymentMethod, orderData) {
    if (['paypal', 'apple_pay', 'google_pay'].includes(orderData)) {
        return "ecomm_express_payment";
    }
    else if (orderData.hasHonorCard) {
        return "ecomm_shipping";
    }
    else {
        return "ecomm";
    }
}
function mapOrderData(orderData) {
    var paymentMethod = getPaymentMethod(orderData);
    return {
        transaction_id: orderData.order_ref,
        payment_method_option: getPaymentMethod(orderData),
        checkout_type: getCheckoutType(paymentMethod, orderData),
        total_price: +orderData.total,
        campaign_code: orderData.cssc,
    };
}
function getCoverTheFeeData(products) {
    var coverTheFeeProduct = products.find(function (_a) {
        var name = _a.name;
        return name.toLowerCase().includes("cover the fee");
    });
    return coverTheFeeProduct || null;
}
export function myImpactPurchaseHandler(e) {
    var _this = this;
    var orderData = (e === null || e === void 0 ? void 0 : e.detail).orderData;
    if (!orderData || !orderData.line_items || !orderData.line_items.length) {
        // Log Issue
        console.warn("order data missing!");
        return;
    }
    (function () { return __awaiter(_this, void 0, void 0, function () {
        var items, supporter_id, _a, productItems, event_label, hasHonorCard, _b, transaction_id, checkout_type, total_price, campaign_code, payment_method_option, coverTheFeeProduct, ehash, eventData;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    items = orderData.line_items;
                    supporter_id = orderData.supporter_number;
                    _a = mapProductItems(items, orderData), productItems = _a.productItems, event_label = _a.event_label, hasHonorCard = _a.hasHonorCard;
                    _b = mapOrderData(__assign(__assign({}, orderData), { hasHonorCard: hasHonorCard })), transaction_id = _b.transaction_id, checkout_type = _b.checkout_type, total_price = _b.total_price, campaign_code = _b.campaign_code, payment_method_option = _b.payment_method_option;
                    coverTheFeeProduct = getCoverTheFeeData(items);
                    return [4 /*yield*/, toEhashAsync(orderData.email)];
                case 1:
                    ehash = _c.sent();
                    eventData = normalizeObject({
                        "event": "purchase",
                        "event_action": "purchase",
                        "event_category": "ecommerce",
                        "event_label": event_label,
                        "payment_method_option": payment_method_option,
                        "site_transaction_id": transaction_id,
                        "site_transaction_status": "pending",
                        "non_interaction": true,
                        "campaign_code": campaign_code,
                        "supporter_id": supporter_id,
                        "checkout_type": checkout_type,
                        "cover_fee_amount": coverTheFeeProduct && +coverTheFeeProduct.total || "",
                        "cover_fee_selected": !coverTheFeeProduct ? "no_cover_the_fee" : "cover_the_fee",
                        "ehash": ehash,
                        "ecommerce": {
                            "currency": "USD",
                            "value": total_price,
                            "transaction_id": transaction_id,
                            "items": productItems,
                        }
                    });
                    dataLayerPush(eventData);
                    return [2 /*return*/];
            }
        });
    }); })();
}
